<template>
	<div>1</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>